import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';

@Injectable()
export class EventsService {

    constructor(private httpclientService: HttpClientService) { }

    getEventes(role,page){
        return this.httpclientService.getMethod({
            url: '/web/news/queryNewsList/'+role+'/'+page,   //role=0 全国 role=1 工作坊 page为查询第几页
        })
    }

    getDetailEventes(id) {
        return this.httpclientService.getMethod({
            url: '/web/news/queryNewsById/'+id,
        })
    }

    registerConference(data) {
        return this.httpclientService.postMethod({
            url: '/web/news/saveSignB',
            data,

            // url: '/web/news/saveSign/',
            // data: {
            //     signFirstname: fname,
            //     signLastname: lname,
            //     signTheme: theme,
            //     signMail: mail,
            //     signNum: num,
            //     signSchool: school
            // }
        })
    }

    //------ National Conference 页面接口修改 2020-03-12 ------
    // 获取全国会议列表
    getConferences(pageIndex: number, pageSize = 10){
        return this.httpclientService.getMethod({
            url: `/web/activity/search?page=${pageIndex}&rows=${pageSize}`, // &keyword=
        });
    }

    // 获取会议详情
    getConferenceDetail(id: string | number){
        return this.httpclientService.getMethod({
            url: `/web/activity/detail/${id}`,
        });
    }

    // 获取会议报名表单问题
    getConferenceApplyForm(id: number, pageIndex: number, pageSize = 10){
        return this.httpclientService.getMethod({
            url: `/web/activity/question/relation/search?activityId=${id}&page=${pageIndex}&rows=${pageSize}`,
        });
    }

    // 会议报名
    applyConference(data: {
        activityId: number,
        telephone: string,
        answer: any,
    }){
        return this.httpclientService.postMethod({
            url: '/web/activity/sign/put',
            data,
        });
    }
}



// WEBPACK FOOTER //
// /Users/apple/Documents/object/chinaicac-portal/src/app/service/events.service.ts